// Registry of detailed sub-service pages under each capability parent.
// Rendered by pages/ServiceDetailPage.jsx at /capabilities/<parent>/<slug>

import { STRATEGY_SUBPAGES } from "@/data/strategySubPages";
import { INTELLIGENCE_SUBPAGES } from "@/data/intelligenceSubPages";
import { BRAND_SUBPAGES } from "@/data/brandSubPages";
import { DIGITAL_SUBPAGES } from "@/data/digitalSubPages";

export const SERVICE_PARENT = {
  slug: "strategy-commercial-transformation",
  name: "Strategy & Commercial Transformation",
};

export const INTELLIGENCE_PARENT = {
  slug: "market-customer-intelligence",
  name: "Market & Customer Intelligence",
};

export const BRAND_PARENT = {
  slug: "brand-marketing-communications",
  name: "Brand, Marketing & Communications",
};

export const DIGITAL_PARENT = {
  slug: "digital-commerce",
  name: "Digital & Commerce",
};

export const SERVICE_PARENTS = {
  [SERVICE_PARENT.slug]: SERVICE_PARENT,
  [INTELLIGENCE_PARENT.slug]: INTELLIGENCE_PARENT,
  [BRAND_PARENT.slug]: BRAND_PARENT,
  [DIGITAL_PARENT.slug]: DIGITAL_PARENT,
};

export const SERVICE_PAGES = STRATEGY_SUBPAGES;

export const ALL_SERVICE_PAGES = [
  ...SERVICE_PAGES.map((p) => ({ ...p, parent: SERVICE_PARENT.slug })),
  ...INTELLIGENCE_SUBPAGES.map((p) => ({ ...p, parent: INTELLIGENCE_PARENT.slug })),
  ...BRAND_SUBPAGES.map((p) => ({ ...p, parent: BRAND_PARENT.slug })),
  ...DIGITAL_SUBPAGES.map((p) => ({ ...p, parent: DIGITAL_PARENT.slug })),
];

export const NAV_SUBMENUS = {
  [SERVICE_PARENT.slug]: SERVICE_PAGES,
  [INTELLIGENCE_PARENT.slug]: INTELLIGENCE_SUBPAGES,
  [BRAND_PARENT.slug]: BRAND_SUBPAGES,
  [DIGITAL_PARENT.slug]: DIGITAL_SUBPAGES,
};
